import parcelTypes from "../../../constants/parcelTypes";

export default {
  namespaced: true,
  state: {
    notice: {},
  },
  getters: {
    notice: state => state.notice,
  },
  actions: {
    resetCurrent: (context) => {
      context.commit('resetCurrent');
    },
    setNotice: (context, notice) => {
      context.commit("setNotice", notice);
    } 
  },
  mutations: {
    resetCurrent: (state) => {
      state.notice = {};
    },
    setNotice: (state, notice) => { 
      state.notice = { ...notice }; //make a "deep" copy

      if (state.notice.parcelType === parcelTypes.Untracked) {
        // in case user switched between notice types, clear all tracking numbers
        state.notice.trackingNumber1 = null;
        state.notice.trackingNumber2 = null;
        state.notice.trackingNumber3 = null;
    }

    }
  }
}
